<template>
    <div class="no-more">
        <p>No more.</p>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
export default Vue.extend({
    name: 'NoMore',
    data () {

        return {
        };

    },
    methods: {

    }
});
</script>

<style scoped lang="less">
    .no-more{
        width: 100%;
        padding: 48px 0 100px 0;
        color: @font_secondary;
        @media @mobile{
            padding: 24px 0;
        }
    }
</style>
